/**
 * Where a right click menu goes.
 *
 * Opening down and to the right of the pointer is the habit, and near an edge it
 * opens the other way instead of hanging off the screen.
 */

/** How close to the edge of the screen a menu may come. */
const MARGIN = 8;

/** Where a menu of a given size goes, for a click at a given point. */
export function placeMenu(
  at: { x: number; y: number },
  size: { width: number; height: number },
  screen: { width: number; height: number },
): { left: number; top: number } {
  let left = at.x;
  let top = at.y;

  // The other side of the pointer when this side has no room.
  if (left + size.width > screen.width - MARGIN) left = at.x - size.width;
  if (top + size.height > screen.height - MARGIN) top = at.y - size.height;

  // And never past an edge whichever side it went: a menu taller than the room
  // above and below the pointer is pinned to the top and scrolls.
  left = Math.max(MARGIN, Math.min(left, screen.width - size.width - MARGIN));
  top = Math.max(MARGIN, Math.min(top, screen.height - size.height - MARGIN));

  return { left, top };
}
